
import BaseCeaseAndDesistWidget from '../../../../base/components/sidebar/widgets/CeaseAndDesistWidget.vue'

export default class CeaseAndDesistWidget extends BaseCeaseAndDesistWidget {}
